import React from "react";
import classNames from "classnames";

import Icon from "../common/components/Icon";

import T from "../common/translation";

const Avatar = ({ width }) =>
	<img
		style={{width: `${width}px`}}
		src={require("../../assets/avatar-city-choice-buildings-screen.png")} />

const MessageBox = ({ headerContent, children }) =>
	<div className="c-message-box">
		<header className="c-message-box__header">{headerContent}</header>
		<div className="c-message-box__content">{children}</div>
	</div>

const CaptainMessageHeader = ({ headerText, isReduced, onClick }) =>
	<div className="captain-message__header">
		{headerText}
		<div className="captain-message__toggler" onClick={onClick}>
			{isReduced
				? <Icon icon="arrow-top" />
				: <Icon icon="arrow-bottom" />
			}
		</div>
	</div>

const CaptainMessage = ({ headerText, isReduced, onClick }) => {
	const captainMessageClasses = classNames({
		"captain-message": true,
		"is-reduced": isReduced
	});
	const avatarClasses = classNames({
		"captain-message__avatar-wrapper": true,
		"captain-message__avatar-wrapper-is-reduced": isReduced
	});
	const captainMessageHeader = (
		<CaptainMessageHeader
			headerText={headerText}
			isReduced={isReduced}
			onClick={onClick} />
	);

	return (
		<div className={captainMessageClasses}>
			<div className={avatarClasses}>
				<Avatar width={180} />
			</div>
			<div className="capitaine-message__message-box-wrapper">
				<MessageBox headerContent={captainMessageHeader}>
					<b>{T("9 buildings have been preconfigured for you.")}</b>
					{T("Simply click on the one you want to edit.")}<br />
					<br />
					<b>{T("Can't find your happiness?")}</b>
					{T("You just need to create one by clicking the button at the bottom right of this screen.")}
				</MessageBox>
			</div>
		</div>
	);
}

export default CaptainMessage;



// WEBPACK FOOTER //
// ./src/js/clone-v2/CaptainMessage.js